<template>
  <div v-if="useIntents" class="cp__order__item__inputs">
    <template v-if="intents && intents.length">
      <b-button v-for="(intent, index) in intents" v-bind:key="'action-btn-'+intent"
                class="btn-outline-success" variant="secondary" @click="select($event, intent)"
                :class="{'d-none': !showAllIntents && intents.length > 3 && index > 2}"
      >
        <span>{{getIntentLabel(intent)}}</span>
      </b-button>
      <div v-if="intents.length > 3" class="more-options" @click.stop="showAllIntents = !showAllIntents">
        <hr class="more-options-separator d-block d-lg-none" />
        <span><template v-if="showAllIntents">Hide</template><template v-else>Show</template> More Options</span>
        <svg v-if="showAllIntents" xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
          <path d="M11.5 6.5L6.5 1.5L1.5 6.5" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
          <path d="M1.5 1.5L6.5 6.5L11.5 1.5" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </template>
  </div>
  <b-button v-else block class="item-select-btn no-outline-btn position-relative" @click="select($event)">
    <span v-show="selected">Selected!</span>
    <template v-show="!selected">
      <span class="flex-1" :class="{'mr-1': itemSelectIcon}">{{itemSelectLabel}}</span>
      <font-awesome-icon class="position-absolute" v-if="itemSelectIcon" :icon="['fas', itemSelectIcon]"></font-awesome-icon>
    </template>
  </b-button>
</template>

<script>
import {IntentLabels} from '@/constants'

export default {
  name: 'SelectItemButtons',
  props: {
    selected: {
      type: Boolean,
      default: function() {
        return false
      }
    },
    useIntents: {
      type: Boolean,
      default: function() {
        return false
      }
    },
    intents: {
      type: Array,
      default: function() {
        return []
      }
    },
    itemSelectLabel: {
      type: String,
      default: function() {
        return 'Select'
      }
    },
    itemSelectIcon: {
      type: String,
      default: function() {
        return 'angle-right'
      }
    }
  },
  data: function() {
    return {
      showAllIntents: false
    }
  },
  methods: {
    getIntentLabel: function(intent) {
      return IntentLabels[intent]
    },
    select: function(event, intent) {
      event.stopPropagation()
      this.$emit('select', intent)
    }
  }
}
</script>

<style scoped>

</style>
